export default __webpack_public_path__ + "static/media/products.215b84b9.svg";